
import React, { useEffect, useState } from 'react';
import BtnWhiteBlackBorderBigSize from '../../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import PurpleInfo from '../../../../Shared/PurpleInfo/PurpleInfo';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import moment from 'moment';

import iconLight from '../../images/icon-light.svg';
import alertIcon from '../../images/alert-yellow.svg';
import Image from 'app/Components/Shared/Image/image';
const packageExistDetails = (props) => {
    const [duration, setDuration] = useState(null);
    const [date, setDate] = useState('');

    useEffect(() => {
        let selectedPackage = props.selectedPackage;
        if (selectedPackage.vasList) {
            let existingVas = selectedPackage?.vasList?.find(x => x.action == "Existing");
            if (existingVas) {
                selectedPackage = existingVas;
            }
        }
        if (selectedPackage.duration?.amount != 0) {
            let date = moment(selectedPackage?.expirationDate, "YYYYMMDD")?.format("DD.MM.YYYY");
            setDate(date);
            if (selectedPackage.duration?.amount == 1) {
                setDuration("יום אחד");
            }
            else if (selectedPackage.duration?.amount > 1) {
                setDuration(selectedPackage.duration.amount + ' ימים ');
            }
        }
    }, [props.selectedPackage]);

    const getExistingPackage = () => {
        let selectedPackage = props.selectedPackage;
        const existingVas = selectedPackage?.vasList?.find(v => v.action == "Existing");
        return existingVas ?? selectedPackage;
    };

    const existingPackage = getExistingPackage();
    const isHboPackage = existingPackage.subList?.[0]?.Code?.toLowerCase() === 'hbo' || props.selectedPackage.cmsData?.id?.toLowerCase?.().includes('hbo');
    const isDisneyPackage = existingPackage.subList?.[0]?.Code?.toLowerCase() === 'dis' || props.selectedPackage.cmsData?.id?.toLowerCase?.().includes('dis');
    const provisionStatus = existingPackage.provisionStatus ?? props.selectedPackage.provisionStatus;

    return (<div className='premium-package-catalog-exist-details'>
        <div className='info-wrapper'>
            {props.selectedPackage.cmsData?.selfCare?.lawText &&
             <p className='info'>
                <Image src={iconLight} alt='icon-light' className='info-icon' />
                <span className='info-text'>{props.selectedPackage.cmsData?.selfCare?.lawText}</span>
            </p>}
        </div>
        {isHboPackage && provisionStatus == "B" && (
            <PurpleInfo text='כדי לצפות בתכנים יש ליצור חשבון ב-HBO Max'>
                <BtnSubmit text='ל- HBO Max' onclick={props.onHboRegistrationClick} />
            </PurpleInfo>
        )}
        {isDisneyPackage && provisionStatus == "B" && (
            <PurpleInfo text='כדי לצפות בתכנים יש ליצור חשבון בדיסני+'>
                <BtnSubmit text='ל- Disney+' onclick={props.onDisneyRegistrationClick} />
            </PurpleInfo>
        )}
        {isDisneyPackage && provisionStatus == "D" && (
            <div className='returning-customer-banner'>
                <PurpleInfo text={
                    <span className='returning-customer-banner__content'>
                        <span className="provisioning-page__info-icon-wrapper">
                            <Image src={alertIcon} alt="" className="provisioning-page__info-icon" />
                        </span>
                        <span className='returning-customer-banner__text'>
                            זיהינו שכבר היה לך חשבון דיסני+, יש להתחבר עם<br />החשבון שנרשמת איתו כדי להתחיל ולצפות בתכנים
                        </span>
                    </span>
                }>
                    <BtnSubmit text='לדיסני+' onclick={props.onDisneyRegistrationClick} />
                </PurpleInfo>
            </div>
        )}
        {duration &&
            <div className='daily-package-info'>
                <div>מנוי חד פעמי עבור {duration}</div>
                <div>מסתיים בסוף יום ה - {date}</div>
            </div>}
        <BtnWhiteBlackBorderBigSize text={'חזרה לכל החבילות'} onclick={() => props.onClickBtnBack()} />
        {!duration && <div className='bottom-options'>
            {props.selectedPackage.subList?.[0]?.Code?.toLowerCase() === 'hbo' && <button className='btn-remove-package' onClick={props.onClickHboChangeButton}>שינוי חבילה</button>}
            <button className='btn-remove-package' onClick={props.onClickRemovePackageButton}>ביטול החבילה</button>
        </div>}
    </div>)

}
export default packageExistDetails;
